import React from 'react';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './regulations-page.base.scss';

const RegulationsBase: React.FC = () => (
    <section className="regulations">
        <h2 className="regulations__title">Regulamin Skąpiec.pl</h2>
        <p className="regulations__wrapper regulations__title-text">
            Ostatnia aktualizacja <time dateTime="2025-03-26">26.03.2025</time> r.
        </p>
        <a
            href="/regulamin-uzytkownika"
            target={LinkTarget.BLANK}
            rel={SeoLinkRelEnum.NOOPENER_NOREFERRER}
        >
            Regulamin dla użytkowników serwisu skąpiec.pl (obowiązuje od 26.03.2025 r.)
        </a>
        <p className="regulations__wrapper">
            Drodzy Użytkownicy! Uprzejmie informujemy, że europejska platforma internetowego rozstrzygania sporów (ODR)
            zostaje zlikwidowana w dniu 20 lipca 2025 r. Możliwość składania nowych skarg za pośrednictwem platformy
            ODR wygasa już 20 marca 2025 r. Spory można nadal rozstrzygać polubownie przed podmiotami wskazanymi w
            rejestrze UOKiK:
            {' '}
            <a
                href="https://polubowne.uokik.gov.pl/rejestr,5,pl.html"
                target={LinkTarget.BLANK}
                rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
            >
                https://polubowne.uokik.gov.pl/rejestr,5,pl.html
            </a>
        </p>
        <p className="regulations__wrapper">
            Dostosowaliśmy Regulamin Serwisu Skąpiec do Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2022/2065
            z dnia 19 października 2022 r. w sprawie jednolitego rynku usług cyfrowych oraz zmiany dyrektywy 2000/31/WE
            (<a
                href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32022R2065&qid=1684434616250"
                target={LinkTarget.BLANK}
                rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
            >Akt o Usługach Cyfrowych</a>) - Digital Services Act („DSA”), który  obowiązuje w stosunku do nas
            od <span className="regulations__title-text">17 lutego 2024 roku.</span>
        </p>
        <ul className="regulations__list regulations__list--decimal">
            <li>
                Informujemy, iż dla nowych Użytkowników, zmieniony Regulamin jest obowiązujący
                od <span className="regulations__title-text">02.2024</span> roku. Dla dotychczasowych
                Użytkowników, <span className="regulations__text">zmiany Regulaminu, dokonane z ważnej przyczyny, jaką
                jest konieczność dostosowanie się usługodawcy do nowych przepisów prawa,</span> wchodzą w
                życie <span className="regulations__text">od dnia</span> ich ogłoszenia. W przypadku nie zaakceptowania
                zmian w Regulaminie, Użytkownik powinien powstrzymać się od korzystania z Serwisu.
            </li>
        </ul>
        <h3 className="regulations__wrapper regulations__subtitle">Co zmieniliśmy w Regulaminie: **</h3>
        <ul className="regulations__list regulations__list--desc">
            <li className="regulations__item">
                Informujemy o usłudze platformy internetowej, zgodnie z definicjami Aktu o usługach cyfrowych;
            </li>
            <li className="regulations__item">
                Informujemy, że <span className="regulations__text">Treści publikowane w Serwisie Skąpiec stanowią
                informację handlową</span> lub zawiera informację handlową;
            </li>
            <li className="regulations__item">
                Zaktualizowaliśmy <span className="regulations__text">kategorie Zakazanych Treści</span>, które
                stanowią treści niezgodne z Regulaminem Serwisu lub nielegalne treści;
            </li>
            <li className="regulations__item">
                Informujemy o moderacji, systemach rekomendujących;
            </li>
            <li className="regulations__item">
                Informujemy o możliwości zgłaszania niezgodnych z Regulaminem lub nielegalnych treści za
                pomocą <span className="regulations__subtitle">zautomatyzowanego mechanizmu NOTICE&ACTION</span> ++
                oraz o obowiązku informowania zgłaszającego o decyzji podjętej w wyniku zgłoszenia;
            </li>
            <li className="regulations__item">
                Informujemy o możliwości zawieszenia zgłaszania nielegalnych treści osobie, która często dokonuje
                oczywiście bezzasadnych zgłoszeń, a także zgłaszającym nadmiarowo oczywiście nieuzasadnione skargi;
            </li>
            <li className="regulations__item">
                Informujemy o prawie skargi na naszą decyzję w ciągu 6 miesięcy oraz o
                wdrożeniu <span className="regulations__subtitle">Wewnętrznego Systemu Rozpatrywania Skarg</span>;
            </li>
            <li className="regulations__item">
                Wskazujemy możliwości wyboru <span className="regulations__text">certyfikowanego organu pozasądowego
                rozstrzygania sporów</span>;
            </li>
            <li>
                Informujemy o utworzeniu <span className="regulations__subtitle">Jednego Punktu Kontaktowego</span> do
                kontaktu dla organów publicznych, jak i dla Użytkowników.
            </li>
        </ul>
    </section>
);

export default RegulationsBase;
